import React from 'react';
import { 
  AiOutlineCheckCircle, 
  AiOutlineCloseCircle, 
  AiOutlineExclamationCircle, 
  AiOutlineInfoCircle,
  AiOutlineClose 
} from 'react-icons/ai';

const Notification = ({ notification, onClose }) => {
  const { type, title, message, id } = notification;

  const getIcon = () => {
    const iconSize = 24;
    switch (type) {
      case 'success':
        return <AiOutlineCheckCircle size={iconSize} color="#10B981" />;
      case 'error':
        return <AiOutlineCloseCircle size={iconSize} color="#EF4444" />;
      case 'warning':
        return <AiOutlineExclamationCircle size={iconSize} color="#F59E0B" />;
      case 'info':
        return <AiOutlineInfoCircle size={iconSize} color="#3B82F6" />;
      default:
        return <AiOutlineInfoCircle size={iconSize} color="#6B7280" />;
    }
  };

  const getStyles = () => {
    const baseStyles = {
      container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '320px',
        maxWidth: '500px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderLeft: `4px solid ${getBorderColor()}`,
        animation: 'slideIn 0.3s ease-out',
        position: 'relative',
      },
      iconContainer: {
        flexShrink: 0,
        marginTop: '2px',
      },
      content: {
        flex: 1,
        minWidth: 0,
      },
      title: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#111827',
        margin: '0 0 4px 0',
      },
      message: {
        fontSize: '14px',
        color: '#6B7280',
        margin: 0,
        lineHeight: '1.5',
        wordWrap: 'break-word',
      },
      closeButton: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#9CA3AF',
        borderRadius: '4px',
        transition: 'all 0.2s ease',
      },
    };

    return baseStyles;
  };

  const getBorderColor = () => {
    switch (type) {
      case 'success':
        return '#10B981';
      case 'error':
        return '#EF4444';
      case 'warning':
        return '#F59E0B';
      case 'info':
        return '#3B82F6';
      default:
        return '#6B7280';
    }
  };

  const styles = getStyles();

  return (
    <div 
      style={styles.container}
      role="alert"
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <div style={styles.iconContainer}>
        {getIcon()}
      </div>
      
      <div style={styles.content}>
        {title && (
          <h4 style={styles.title}>{title}</h4>
        )}
        <p style={styles.message}>{message}</p>
      </div>
      
      <button
        onClick={() => onClose(id)}
        style={styles.closeButton}
        aria-label="Cerrar notificación"
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#F3F4F6';
          e.currentTarget.style.color = '#374151';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#9CA3AF';
        }}
      >
        <AiOutlineClose size={16} />
      </button>
    </div>
  );
};

export default Notification;

